import React, { useState, useContext, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";

import ContextComponent from "../../../../AppContext";
import Utils from "../../../../Utils";
import DataTable from "../../../../controls/table/DataTable";
import AddIcon from "../../../../../assets/img/add.png";
import EditIcon from "../../../../../assets/img/Edit.png";
import SaveIcon from "../../../../../assets/img/Save.png";
import DeleteIcon from "../../../../../assets/img/Delete.png";
import EmptyPage from "../../../../pages/EmptyPage";

import AddSectionPage from "./section/AddSectionPage";
import EditSectionPage from "./section/EditSectionPage";

const Sections = () => {

  const { siteid } = useParams();
  const projectPath = useParams();
  const projectid = projectPath["projectid"];
  const location = useLocation();

  let [currSiteId, setCurrSiteId] = useState(siteid);
  let [showDeleteModal, setShowDeleteModal] = useState(false);
  let [siteName, setSiteName] = useState("");
  let [selectedItemCount, setSelectedItemCount] = useState(0);
  const DISABLED_ICON = Utils.APP_CLASS_NAMES.disableStyle;
  let [editIconClass, setEditIconClass] = useState(DISABLED_ICON);
  let [saveIconClass, setSaveIconClass] = useState(DISABLED_ICON);

  let [tableSelectedItems, setTableSelectedItems] = useState([]);
  let [sectionIdForEdit, setSectionIdForEdit] = useState("");
  let [allSections, setAllSections] = useState([]);
  const [addDisabled, setAddDisabled] = useState(false);
  const isQuiz = Utils?.getQuizSurveyMapValue(siteid);
  let navigate = useNavigate();

  useEffect(() => {
    if (tableSelectedItems.length === 1) {
      setEditIconClass("");
      setSectionIdForEdit(tableSelectedItems[0]);
    } else {
      setEditIconClass(DISABLED_ICON);
      setSectionIdForEdit("");
    }
  }, [tableSelectedItems]);

  let [editModalCanOpen, setEditModalCanOpen] = useState(false);
  let [editableSection, setEditableSection] = useState({});
  let [editableSectionIndex, setEditableSectionIndex] = useState(-1);

  const openEditModal = (e) => {
    e.preventDefault();
    setEditModalCanOpen(true);
    let targetSection = {};
    allSections.forEach((section, index) => {
      if (section.id === sectionIdForEdit) {
        targetSection = section;
        setEditableSectionIndex(index);
      }
    });
    //console.log(targetUser);
    !Utils.isObjectEmpty(targetSection) && setEditableSection(targetSection);
  };

  let { setCanRedirectToLogin, setLoadingState, setAlert } =
    useContext(ContextComponent);

  let [tableColumns, setTableColumns] = useState([
    "id",
    "select",
    "name",
    "description",
    "sectionColor",
    "sectionTextColor",
    "sectionQuestionColor",
    "order",
  ]);
  let [tableColumnSchema, setTableColumnSchema] = useState({
    id: {
      type: "hidden",
      title: "id",
    },
    select: {
      type: "checkbox",
      title: "-",
      center: true,
    },
    name: {
      type: "link",
      search: true,
      sort: false,
      title: "Name",
      handleLink: (obj) => {
        const sitePath = Utils.APP_URLS.SITE_PAGE.replace(":siteid", currSiteId);
        const siteSectionsPath = Utils.APP_URLS.SITE_SECTIONS.replace(":siteid", currSiteId);
        const sectionPagePath = Utils.APP_URLS.SECTION_PAGE
          .replace(":siteid", currSiteId)
          .replace(":sectionid", obj.id);
        const projectSectionPagePath = Utils.APP_URLS.PROJECT_SECTION_PAGE
          .replace(":projectid", projectid)
          .replace(":siteid", currSiteId)
          .replace(":sectionid", obj.id);

        const isSiteOrSectionsPath = location.pathname === sitePath || location.pathname === siteSectionsPath;
        navigate(isSiteOrSectionsPath ? sectionPagePath : projectSectionPagePath);
      },
    },
    description: {
      type: "text",
      search: false,
      sort: false,
      title: "Section Description",
    },
    sectionColor: {
      type: "color",
      search: true,
      sort: false,
      title: "Color",
    },
    sectionTextColor: {
      type: "color",
      search: true,
      sort: false,
      title: "T-color",
    },
    sectionQuestionColor: {
      type: "color",
      search: false,
      sort: false,
      title: "Q-color",
      center: true,
    },
    order: {
      type: "order",
      search: false,
      sort: true,
      title: "Order",
    },
  });

  let [tableData, setTableData] = useState([]);
  let [canRender, setCanRender] = useState(false);
  let [renderDataTable, setRenderDataTable] = useState(false);
  let [renderEmptyPage, setRenderEmptyPage] = useState(false);
  let [updateTable, setUpdateTable] = useState(false);

  let [orderChanged, setOrderChanged] = useState({});

  const updateTableData = (data) => {
    setAllSections(data);
    let sectionInfo = data;
    let sectionsArray = [];
    if (!Utils.isObjectEmpty(sectionInfo)) {
      sectionsArray = sectionInfo.map((sectionData, index) => {
        let sectionTableObj = [];
        let sectionTableData = [];
        tableColumns.forEach((col) => {
          if (col === "select") {
            sectionTableData.push(false);
          } else if (col === "classicview") {
            // let isSuperAdmin = sectionInfo[index]['superAdmin'];
            // let valueToBePush = isSuperAdmin ? Utils.APP_CONSTANTS.DOUBLE_TICK : sectionInfo[index][col];
            let valueToBePush = sectionInfo?.[index]?.['classicview'] || false;
            sectionTableData.push(valueToBePush);
          } else {
            sectionTableData.push(sectionInfo[index][col]);
          }
        });
        sectionTableObj = sectionTableData;
        return sectionTableObj;
      });
      let name = data[0]?.site ?? '';
      name.length > 0 && setSiteName("(" + name + ")");
      setTableData(sectionsArray);
      setCanRender(true);
    }
  };

  const success = (res) => {
    setLoadingState({
      applyMask: false,
    });
    updateTableData(res.data);

    setRenderDataTable(res.data.length !== 0);
    setRenderEmptyPage(res.data.length === 0);
  };

  const fail = (err) => {
    setLoadingState({
      applyMask: false,
    });
    err?.message?.length && console.log(err);
    if (err?.redirect) {
      setCanRedirectToLogin(true);
    }
  };

  const loadFreshSections = (currSiteId) => {
    Utils.getAllSections({ siteId: currSiteId }).then(success, fail);
  };

  useEffect(() => {
    setLoadingState({
      applyMask: true,
      text: "Loading sections",
    });
    loadFreshSections(currSiteId);
  }, []);

  useEffect(() => {
    if (tableData.length) {
      // console.log("table has data now");
    }
  }, [tableData]);

  const handleShow = async (e) => {
    if (tableSelectedItems?.length > 0) {
      await setSelectedItemCount(tableSelectedItems?.length);
      setShowDeleteModal(true);
    }
  };

  const handleClose = async (e) => {
    await setSelectedItemCount(tableSelectedItems?.length);
    setShowDeleteModal(false);
  };

  const deleteSuccess = (res) => {
    setAlert({
      show: true,
      message: "Section(s) deleted successfully",
    });
    setTableSelectedItems([]);
    setUpdateTable(!updateTable);
  };

  const deleteFail = (err) => {
    err?.message?.length && console.log(err);
    if (err?.redirect) {
      setCanRedirectToLogin(true);
    }
    setAlert({
      show: true,
      message: err?.data?.message
        ? err.data.message
        : "Section(s) deletion failed",
      type: "danger",
    });
  };

  const handleDelete = async (e) => {
    setShowDeleteModal(false);
    // setLoadingState({
    //   applyMask: true,
    //   text: "Deleting selected " + tableSelectedItems.length + " items",
    // });
    let tempTableData = tableData.filter((d) => {
      return tableSelectedItems.indexOf(d[0]) === -1;
    });
    setTableData(tempTableData);
    // console.log(tempTableData);
    Utils.deleteSections(tableSelectedItems).then(deleteSuccess, deleteFail);
  };

  let [addModalCanOpen, setAddModalCanOpen] = useState(false);

  const openAddModal = (e) => {
    e.preventDefault();
    setAddModalCanOpen(true);
  };


  useEffect(() => { }, [editableSection]);
  useEffect(() => {
    setAddDisabled(tableData.length >= 1 && isQuiz);
  }, [tableData, isQuiz]);


  const closeAddModal = (e) => {
    setAddModalCanOpen(false);
  };

  const closeEditModal = (e) => {
    setEditModalCanOpen(false);
  };



  useEffect(() => {
    if (Object.keys(orderChanged).length > 0) {
      let action = orderChanged.action;
      // let currentIdx = (parseInt(orderChanged.current, 10)) - 1;
      let currentIdx = parseInt(orderChanged.current, 10); // changed to rowIndex so zero-based
      let targetIdx = action === "plus" ? currentIdx + 1 : currentIdx - 1;

      setOrderChanged({});

      let orderIndex = tableColumns.indexOf("order");

      // deep clone the table data
      let currentTableDataTemp = JSON.parse(JSON.stringify(tableData));

      // swap rows
      let temp = currentTableDataTemp[currentIdx];
      currentTableDataTemp[currentIdx] = currentTableDataTemp[targetIdx];
      currentTableDataTemp[targetIdx] = temp;

      // update the order property
      currentTableDataTemp.forEach((row, i) => {
        row[orderIndex] = i + 1; // order starts from 1
      });

      setTableData(currentTableDataTemp);
      setSaveIconClass("");
    }

  }, [orderChanged]);

  const handleSaveOrder = (e) => {
    // console.log("in handleSaveOrder...");
    // console.log(tableData);

    setLoadingState({
      applyMask: true,
      text: "Saving order",
    });

    const saveOrderSuccess = (res) => {
      setLoadingState({
        applyMask: false,
      });
      setAlert({
        show: true,
        message: res?.data?.message
          ? res.data.message
          : "Order saved successfully!",
        type: "success",
      });

    };

    const saveOrderFail = (err) => {
      setLoadingState({
        applyMask: false,
      });
      err?.message?.length && console.log(err);
      if (err?.redirect) {
        setCanRedirectToLogin(true);
      }
      setAlert({
        show: true,
        message: err?.data?.message
          ? err.data.message
          : "Order save failed",
        type: "danger",
      });
    };

    let orderObj = [];
    tableData.forEach((item) => {
      orderObj.push(item[0]);
    });

    Utils.saveOrderForSite({ siteId: currSiteId, orderObj }).then(saveOrderSuccess, saveOrderFail);

  }

  return (
    <div className="indi-body-cards-wrapper d-flex w-100">
      <div className="indi-add-card-title">
        <span>Sections <span className="indi-site-name-in-header">{siteName}</span></span>
        <div className="d-none1 w-50 indi-body-actions">
          <div
            className={`indi-body-action ${addDisabled ? DISABLED_ICON : ""}`}
            role="button"
            onClick={openAddModal}
          >
            <img className="indi-w-20" src={AddIcon} alt="Edit-icon"></img>
            Add
          </div>
          <div
            className={`indi-body-action ${editIconClass}`}
            role="button"
            onClick={openEditModal}
          >
            <img className="indi-w-20" src={EditIcon} alt="edit-icon"></img>
            Edit
          </div>
          <div
            className={`indi-body-action ${saveIconClass}`}
            role="button"
            onClick={handleSaveOrder}
          >
            <img className="indi-w-20" src={SaveIcon} alt="save-icon"></img>
            Save
          </div>

          <div className="indi-body-action" role="button" onClick={handleShow}>
            <img className="indi-w-20" src={DeleteIcon} alt="Delete-icon"></img>
            Delete
          </div>
        </div>
      </div>
      {canRender && (
        <>
          {renderDataTable && (
            <DataTable
              minRows={0}
              tableProps={{
                tableColumns,
                tableColumnSchema,
                tableData,
                tableSelectedItems,
                setTableSelectedItems,
                setOrderChanged,
              }}
            />
          )}
          {!renderDataTable && (
            <EmptyPage
              props={{
                emptyMessage: "No sections are available",
              }}
            />
          )}
        </>
      )}

      <Modal centered show={showDeleteModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Delete confirmation?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure to delete select {selectedItemCount} item(s)?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            No
          </Button>
          <Button variant="primary" onClick={handleDelete}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>

      {addModalCanOpen && (
        <AddSectionPage
          props={{
            addModalCanOpen,
            setAddModalCanOpen,
            tableData,
            setTableData,
            loadFreshSections,
            siteName,
          }}
        />
      )}

      {editModalCanOpen && (
        <EditSectionPage
          props={{
            editModalCanOpen,
            setEditModalCanOpen,
            tableData,
            setTableData,
            editableSection,
            editableSectionIndex,
            allSections,
            setAllSections,
            loadFreshSections,
            siteName,
          }}
        />
      )}
    </div>
  );
};

export default Sections;